import { z } from 'zod';
import { PaymentMethodSchema, PaymentSnapshotSchema } from './payment-method-schema';
import { TasaSchema } from '../settings/tasa-schema';

export const InternalTransferDirectionSchema = z.enum([
  'worker_to_business',
  'business_to_worker',
]);

export const InternalTransferParamsSchema = z.object({
  creatorId: z.string().min(1, 'creatorId is required'),
  businessId: z.string().min(1, 'businessId is required'),
  professionalId: z.string().min(1, 'professionalId is required'),
  amountAccounting: z.number().positive('Amount accounting must be positive'),
  amountLocal: z.number().positive('Amount local must be positive'),
  paymentMethod: PaymentMethodSchema,
  tasa: z.number().positive('Tasa must be positive'),
  direction: InternalTransferDirectionSchema,
});

export type InternalTransferParams = z.infer<typeof InternalTransferParamsSchema>;

export const ChargeRentParamsSchema = z.object({
  businessId: z.string().min(1, 'businessId is required'),
  workerId: z.string().min(1, 'workerId is required'),
  amountUSD: z.number().positive('Amount USD must be positive'),
  description: z.string().min(1, 'Description is required'),
  creatorId: z.string().min(1, 'creatorId is required'),
});

export type ChargeRentParams = z.infer<typeof ChargeRentParamsSchema>;

export const ApplyPaymentParamsSchema = z.object({
  saleId: z.string().nullable().optional(),
  appointmentId: z.string().nullable().optional(),
  creatorId: z.string().min(1, 'creatorId is required'),
  professionalId: z.string().nullable(),
  businessId: z.string().nullable().optional(), // Can be null for independent workers
  requestedAmount: z.number().optional(),
  requestedCurrency: z.string().optional(),
  amountLocal: z.number().optional(),
  tasa: z.number().positive('Tasa must be positive'),
  receivedById: z.string().min(1, 'receivedById is required'),
  receiverType: z.enum(['business', 'professional']),
  paymentMethod: PaymentMethodSchema,
  reference: z.string().optional(),
  snapshot: PaymentSnapshotSchema.optional(),
  rates: TasaSchema.optional(),
  activeBusiness: z.any(), // Too complex for a deep zod schema right now, but we can refine
  profile: z.any(),
});

export type ApplyPaymentParams = z.infer<typeof ApplyPaymentParamsSchema>;

export const SettlementParamsSchema = z.object({
  ownerId: z.string().min(1, 'ownerId is required'),
  workerId: z.string().min(1, 'workerId is required'),
  adjustmentUSD: z.number().default(0), // This can be used for manual balance adjustment
  materialCosts: z.number().default(0), // New field for extra material costs
  notes: z.string().optional(), // New field for notes
  creatorId: z.string().min(1, 'creatorId is required'),
  resetBalance: z.boolean(),
});

export type SettlementParams = z.infer<typeof SettlementParamsSchema>;

export const AddExpenseParamsSchema = z.object({
  creatorId: z.string().min(1, 'creatorId is required'),
  businessId: z.string().nullable().optional(),
  professionalId: z.string().nullable(),
  category: z.enum(['supplies', 'rent', 'utilities', 'payroll', 'marketing', 'taxes', 'other']),
  description: z.string().min(1, 'La descripción es obligatoria'),
  amountLocal: z.number().positive('Amount local must be positive'),
  amountAccounting: z.number().positive('Amount accounting must be positive'),
  paymentMethod: PaymentMethodSchema,
  tasa: z.number().positive(),
  receipt_url: z.string().nullable().optional(),
  date: z.any().optional(), // allow custom retro-active date
});

export type AddExpenseParams = z.infer<typeof AddExpenseParamsSchema>;
